import React, { Component } from 'react';
import { connect } from '~/redux/connect';
import { getConfirmNavigationMessages, getRouter } from '~/stateGetter';
import { push, replace } from 'redux-little-router';
import { presentRouterRoute } from '~/statePresenter';

import { Box, Dialog, List } from '~/native-ui';

export class NavigationConfirmDialog extends Component {
    static propTypes = {};

    state = {
        confirmNavigationMessages: [],
    };

    componentWillMount = () => {
        let confirmNavigationMessages = this.props.confirmNavigationMessages;
        this.setState({ confirmNavigationMessages });
    };

    componentWillReceiveProps = (nextProps) => {
        let confirmNavigationMessages = nextProps.confirmNavigationMessages;

        if (confirmNavigationMessages.length < 1) {
            return;
        }

        this.setState({ confirmNavigationMessages });
    };

    isNavigationConfirmDialogShown = () => {
        return this.props.confirmNavigationMessages.length > 0;
    };

    getConfirmMessages = () => {
        let { confirmNavigationMessages } = this.state;

        if (confirmNavigationMessages.length === 1) {
            return <Box>{confirmNavigationMessages[0]}</Box>;
        }

        return (
            <List>
                {confirmNavigationMessages.map((message, i) => (
                    <List.Item ul={false} ol={false} key={i}>
                        {message}
                    </List.Item>
                ))}
            </List>
        );
    };

    render() {
        let { trans } = this.props;

        const actions = [
            { label: trans('confirmNavigation.yes'), onClick: this.props.continueNavigation },
            { label: trans('confirmNavigation.no'), onClick: this.props.cancelNavigation },
        ];

        return (
            <Dialog
                actions={actions}
                onOverlayClick={this.props.cancelNavigation}
                onEscKeyDown={this.props.cancelNavigation}
                active={this.isNavigationConfirmDialogShown()}
                title={trans('confirmNavigation.title')}
                type="normalsmall"
            >
                {this.getConfirmMessages()}
            </Dialog>
        );
    }
}
const RXNavigationConfirmDialog = connect(
    (state) => {
        return {
            confirmNavigationMessages: getConfirmNavigationMessages(state),
            router: getRouter(state),
        };
    },
    (dispatch) => {
        return {
            push: (url, options) => dispatch(push(url, options)),
            replace: (url, options) => dispatch(replace(url, options)),
        };
    },
    ({ router, ...props }, { push, replace, ...otherDispatchers }, ownProps) => {
        let currentRoute = presentRouterRoute(router),
            previousRoute = router.previous ? presentRouterRoute(router.previous) : null;

        return {
            ...props,
            ...otherDispatchers,

            continueNavigation: () => {
                let options = currentRoute.options;
                replace(currentRoute, { ...options, confirmed: true });
            },
            cancelNavigation: () => {
                if (!previousRoute) {
                    return;
                }

                push(previousRoute, { confirmed: true });
            },
        };
    }
)(NavigationConfirmDialog);

export default RXNavigationConfirmDialog;
